import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';

const estiloPadrao = {
  border: '1px solid #388e3c',
  borderRadius: '8px',
};

export default function CampoClinico({
  control,
  name,
  controlId,
  label,
  isFuncionario,
  isReadOnly,
  onSave,
  style = estiloPadrao,
  placeholder,
  textarea = true,
  labelClassName,
  groupAs,
  omitSize = false,
  header,
}) {
  return (
    <Form.Group
      {...(omitSize ? {} : { size: 'sm' })}
      {...(groupAs ? { as: groupAs } : {})}
      controlId={controlId}
    >
      {header ? (
        <div className="mb-1 d-flex align-items-center justify-content-between">
          <Form.Label className={labelClassName}>
            <strong>{label}</strong>
          </Form.Label>
          {header}
        </div>
      ) : (
        <Form.Label className={labelClassName}>
          <strong>{label}</strong>
        </Form.Label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Form.Control
            value={isFuncionario ? '********** ACESSO RESTRITO **********' : field.value || ''}
            disabled={isReadOnly}
            onChange={field.onChange}
            onBlur={(e) => {
              field.onBlur(e);
              onSave();
            }}
            ref={field.ref}
            style={style}
            {...(placeholder ? { placeholder } : {})}
            {...(textarea
              ? {
                  as: 'textarea',
                  rows: field.value ? Math.max(field.value.split('\n').length, 3) : 3,
                }
              : {})}
          />
        )}
      />
    </Form.Group>
  );
}
